<template>
  <div id="paginaRegContabili">
    <!-- Elementi Pagina----------------------------------------------------------------------------------- -->
    <b-row class="match-height">

      <!-- Card Grid View: GridElencoRegContabili -->
      <b-col xl="12" md="12">
        <b-card tag="article" class="mb-2">
          <b-card-header class="align-items-baseline">
            <div>
              <b-card-title>Elenco Registrazioni Contabili</b-card-title>
              <b-card-text class="mb-0">
                Teatro Coccia
              </b-card-text>
            </div>
            <!-- dropdown menù laterale dx -->
            <b-dropdown variant="link" no-caret right class="chart-dropdown" toggle-class="p-0">
              <template #button-content>
                <feather-icon icon="MoreVerticalIcon" size="18" class="text-body cursor-pointer" />
              </template>
              <b-dropdown-item href="#">
                ...
              </b-dropdown-item>
            </b-dropdown>
          </b-card-header>
          <b-card-body class="mb-0">
            <b-row>
              <b-col xl="4" md="4" class="pt-1">
                <label for="dataInizio" class="h5">Dal</label>
                <ejs-datepicker
                  id="dataInizio"
                  v-model="dataInizio"
                  :format="settings.formatoData"
                />
              </b-col>
              <b-col xl="4" md="4" class="pt-1">
                <label for="dataFine" class="h5">Al</label
                >
                <ejs-datepicker
                  id="dataFine"
                  v-model="dataFine"
                  :format="settings.formatoData"
                />
              </b-col>
              <b-col xl="2" md="2" class="mt-3">
                <ejs-button id="cercaRegistrazioni" cssClass="e-flat"
                  @click.native="cercaRegistrazioni()">Cerca</ejs-button>
              </b-col>
            </b-row>
            <!-- card body -->
            <b-row>
              <!-- Timer Alert -->
              <b-col xl="6" md="12">
                <b-alert :show="alertADismissCountDown" dismissible variant="warning"
                  @dismissed="alertADismissCountDown = 0" @dismiss-count-down="alertACountDownChanged">
                  <p>Occorre selezionare una riga della tabella</p>
                  <b-progress variant="warning" :max="alertADismissSecs" :value="alertADismissCountDown" height="4px" />
                </b-alert>
              </b-col>
              <b-col xl="12" md="12" class="pt-1">

                <ejs-grid id="gridA" ref="gridA" :dataSource="regContabiliFullData" :allowSorting="true"
                  :toolbarClick="gridAClickHandler" :toolbar="gridA.toolbarOptions" :height="gridA.height"
                  :allowFiltering="true" :filterSettings="gridA.filterOptions" :editSettings="gridA.editOptions"
                  :actionBegin="gridAactionBegin" :actionComplete="gridAactionComplete"
                  :allowGrouping="true" :groupSettings="gridA.groupOptions">
                  <e-columns>
                    <e-column field="codiceunivocodiscaricamento" headerText="ID" :isPrimaryKey="true" width="130"></e-column>
                    <e-column field="dataregistrazione" headerText="Data Registr." width="160"></e-column>
                    <e-column field="codicecausale" headerText="Cod. Causale " width="160"></e-column>
                    <e-column field="descrizionecausale" headerText="Descr. Causale" width="200"></e-column>
                    <e-column field="importototale_lordo" headerText="Importo Tot" width="150"></e-column>
                    <e-column field="cliforcodicefiscale" headerText="Rif. Soggetto" width="160"></e-column>
                    <e-column field="denominazioneSoggetto" headerText="Den. Soggetto" width="160"></e-column>
                    <e-column field="centroCosto" headerText="Centro di Costo" width="200"></e-column>
                    <e-column field="note" headerText="Note" width="200"></e-column>
                  </e-columns>
                </ejs-grid>
              </b-col>
            </b-row>
          </b-card-body>
        </b-card>
      </b-col>
    </b-row>

    <!-- dialogA1: dialogDettaglioRegContabile ---------------------------------------------------------------------------------------------------- -->
    <ejs-dialog id="dialogA1" ref="dialogA1" :header="dialogA1.header" :buttons="dialogA1.buttons"
      :visible="dialogA1.visible" :showCloseIcon="dialogA1.showCloseIcon" :close="dialogA1Close" :open="dialogA1Open"
      :zIndex="dialogA1.zIndex" :animationSettings="dialogA1.animationSettings">
      <!-- Content dialog -->
      <b-tabs ref="tabAdialogA1" v-model="dialogA1.tabAdialogA1Index">
        <b-tab title="Anagrafica" @click="tabClicked('dialogA1Tab01')">
          <b-row class="match-height">
            <!-- Card con Elementi Input: dettagli registrazione contabile -->
            <b-col xl="12" md="12">
              <b-card tag="article" class="mb-2">
                <b-card-header class="align-items-baseline">
                  <div>
                    <b-card-title>Estremi Registrazione</b-card-title>
                    <b-card-text class="mb-0" />
                  </div>
                  <b-dropdown variant="link" no-caret right class="chart-dropdown" toggle-class="p-0">
                    <template #button-content>
                      <feather-icon icon="MoreVerticalIcon" size="18" class="text-body cursor-pointer" />
                    </template>
                    <b-dropdown-item href="#">
                      ...
                    </b-dropdown-item>
                  </b-dropdown>
                </b-card-header>
                <b-card-body class="mb-0">
                  <!-- card body -->
                  <b-row>

                    <b-col xl="4" md="12" class="mb-2">
                      <label for="dataRegistrazione" class="h5">Data Registrazione</label>
                      <ejs-datepicker id="dataRegistrazione" v-model="regContabiliActiveData.dataregistrazione"
                        :format="settings.formatoData" placeholder="Data Registrazione" :readonly="true" />
                    </b-col>

                    <b-col xl="4" md="12" class="mb-2">
                      <label for="codicecausale" class="h5">Codice Causale</label>
                      <ejs-textbox id="codicecausale" v-model="regContabiliActiveData.codicecausale" floatLabelType="Never"
                        cssClass="" placeholder="Codice Causale" showClearButton="true" type="text" autocomplete="false" :readonly="true" />
                    </b-col>

                    <b-col xl="4" md="12" class="mb-2">
                      <label for="importoTotale" class="h5">Importo Totale</label>
                      <ejs-numerictextbox id="importoTotale" v-model="regContabiliActiveData.importototale_lordo" floatLabelType="Never"
                        cssClass="" format="###.## €" placeholder="Importo Totale" showSpinButton="false"
                        showClearButton="true" :readonly="true" />
                    </b-col>

                    <b-col xl="4" md="12" class="mb-2">
                      <label for="ivatotale" class="h5">Iva Totale</label>
                      <ejs-numerictextbox id="ivatotale" v-model="regContabiliActiveData.ivatotale" floatLabelType="Never"
                        cssClass="" format="###.## €" placeholder="IVA Totale" showSpinButton="false"
                        showClearButton="true" :readonly="true" />
                    </b-col>

                    <b-col xl="4" md="12" class="mb-2">
                      <label for="cliforcodicefiscale" class="h5">Riferimento Soggetto</label>
                      <ejs-textbox id="cliforcodicefiscale" v-model="regContabiliActiveData.cliforcodicefiscale" floatLabelType="Never"
                        cssClass="" placeholder="Riferimento Soggetto" showClearButton="true" type="text" autocomplete="false" :readonly="true" />
                    </b-col>

                    <b-col xl="4" md="12" class="mb-2">
                      <label for="note" class="h5">Note</label>
                      <ejs-textbox id="note" v-model="regContabiliActiveData.note" floatLabelType="Never"
                        cssClass="" placeholder="Note" showClearButton="true" type="text" autocomplete="false" :readonly="true" />
                    </b-col>
                  </b-row>
                </b-card-body>
              </b-card>
            </b-col>

            <!-- Card Grid View: GridElencoRighiContabili -->
            <b-col xl="12" md="12">
              <b-card tag="article" class="mb-2">
                <b-card-header class="align-items-baseline">
                  <div>
                    <b-card-title>Dettaglio Righi Contabili</b-card-title>
                    <b-card-text class="mb-0">
                      Teatro Coccia
                    </b-card-text>
                  </div>
                  <!-- dropdown menù laterale dx -->
                  <b-dropdown variant="link" no-caret right class="chart-dropdown" toggle-class="p-0">
                    <template #button-content>
                      <feather-icon icon="MoreVerticalIcon" size="18" class="text-body cursor-pointer" />
                    </template>
                    <b-dropdown-item href="#">
                      ...
                    </b-dropdown-item>
                  </b-dropdown>
                </b-card-header>
                <b-card-body class="mb-0">
                  <!-- card body -->
                  <b-row>
                    <!-- Timer Alert -->
                    <b-col xl="6" md="12">
                      <b-alert :show="alertADismissCountDown" dismissible variant="warning"
                        @dismissed="alertADismissCountDown = 0" @dismiss-count-down="alertACountDownChanged">
                        <p>Occorre selezionare una riga della tabella</p>
                        <b-progress variant="warning" :max="alertADismissSecs" :value="alertADismissCountDown"
                          height="4px" />
                      </b-alert>
                    </b-col>

                    <b-col xl="12" md="12" class="pt-1">

                      <ejs-grid id="gridB" ref="gridB" :dataSource="righeContabiliActiveData" :allowSorting="true"
                        :toolbarClick="gridAClickHandler" :toolbar="gridB.toolbarOptions" :height="gridB.height"
                        :allowFiltering="true" :filterSettings="gridB.filterOptions" :editSettings="gridB.editOptions"
                        :actionBegin="gridAactionBegin" :actionComplete="gridAactionComplete">
                        <e-columns>
                          <e-column field="id" headerText="ID" :isPrimaryKey="true" width="130"></e-column>
                          <e-column field="conto" headerText="Conto" width="150"></e-column>
                          <e-column field="descrizione" headerText="Descrizione" width="150"></e-column>
                          <e-column field="importodare" headerText="Importo Dare" width="150"></e-column>
                          <e-column field="importoavere" headerText="Importo Avere" width="150"></e-column>
                          <e-column field="cliforcodicefiscale" headerText="Riferimento Soggetto" width="150"></e-column>
                          <e-column field="densoggetto" headerText="Denominazione Soggetto" width="200"></e-column>
                          <e-column field="note" headerText="Note" width="300"></e-column>
                        </e-columns>
                      </ejs-grid>
                    </b-col>
                  </b-row>
                </b-card-body>
              </b-card>
            </b-col>

            <!-- Card con Elementi Input: Caratteristiche -->
            <b-col xl="12" md="12">
              <b-card tag="article" class="mb-2">
                <b-card-header class="align-items-baseline">
                  <div>
                    <b-card-title>Dettagli Assegnazione Destinatari</b-card-title>
                    <b-card-text class="mb-0" />
                  </div>
                  <b-dropdown variant="link" no-caret right class="chart-dropdown" toggle-class="p-0">
                    <template #button-content>
                      <feather-icon icon="MoreVerticalIcon" size="18" class="text-body cursor-pointer" />
                    </template>
                    <b-dropdown-item href="#">
                      ...
                    </b-dropdown-item>
                  </b-dropdown>
                </b-card-header>
                <b-card-body class="mb-0">'
                  <!-- card body -->
                  <b-row>

                    <b-col xl="12" md="12" class="mb-2">
                      <label for="commenti" class="h5">Commenti</label>
                      <ejs-textbox id="commenti" v-model="dettAssegnazioneActiveData.commenti" floatLabelType="Never"
                        cssClass="" placeholder="Commenti" showClearButton="true" type="text" autocomplete="false" />
                    </b-col>
                  </b-row>
                  <b-row>
                    <b-col xl="3" md="6" class="mb-2">
                      <label for="cat_teatroCoccia" class="h5">Categoria Bilancio Teatro Coccia</label>
                      <ejs-dropdownlist
                        id="cat_teatroCoccia"
                        v-model="dettAssegnazioneActiveData.cat_teatroCoccia"
                        :dataSource="cat_teatroCocciaList"
                        :fields="cat_teatroCocciaFields"
                        :allowFiltering="true"
                        showClearButton="true"
                        :change="resetPercTeatroCoccia"
                      />
                    </b-col>
                    <b-col xl="2" md="4" class="mb-2">
                      <label for="iva_teatroCoccia" class="h5 mr-2">IVA Teatro Coccia</label>
                      <ejs-checkbox id="iva_teatroCoccia" v-model="dettAssegnazioneActiveData.iva_teatroCoccia" ref="iva_teatroCoccia"
                        :checked="dettAssegnazioneActiveData.iva_teatroCoccia" name="iva_teatroCoccia" :change="aggiornaQuotaTeatroCoccia" />
                    </b-col>
                    <b-col xl="3" md="6" class="mb-2">
                      <label for="p_teatroCoccia" class="h5">% Applicazione Bilancio Teatro Coccia</label>
                      <ejs-numerictextbox id="p_teatroCoccia" ref="p_teatroCoccia" v-model="dettAssegnazioneActiveData.p_teatroCoccia"
                        floatLabelType="Never" cssClass="" format="###.##" placeholder="Percentuale applicazione Bilancio Teatro Coccia"
                        showSpinButton="false" showClearButton="true" :min="min" :max="max" :step="step" :change="aggiornaQuotaTeatroCoccia" />
                    </b-col>
                    <b-col xl="4" md="6" class="mb-2">
                      <label for="quota_teatroCoccia" class="h5">Quota Teatro Coccia</label>
                      <ejs-numerictextbox id="quota_teatroCoccia" ref="quota_teatroCoccia" v-model="dettAssegnazioneActiveData.quota_teatroCoccia"
                        floatLabelType="Never" cssClass="" format="€ ###.##"
                        placeholder="Quota Teatro Coccia" showSpinButton="false" showClearButton="true" />
                    </b-col>
                  </b-row>
                  <b-row>
                    <b-col xl="3" md="6" class="mb-2">
                      <label for="cat_ministero" class="h5">Categoria Bilancio Ministero Entrate/Uscite</label>
                      <ejs-dropdownlist
                        id="cat_ministero"
                        v-model="dettAssegnazioneActiveData.cat_ministero"
                        :dataSource="cat_ministeroList"
                        :fields="cat_ministeroFields"
                        :allowFiltering="true"
                        showClearButton="true"
                        :change="resetPercMinistero"
                      />
                    </b-col>
                    <b-col xl="2" md="4" class="mb-2">
                      <label for="iva_ministero" class="h5 mr-2">IVA Ministero</label>
                      <ejs-checkbox id="iva_ministero" v-model="dettAssegnazioneActiveData.iva_ministero" ref="iva_ministero"
                        :checked="dettAssegnazioneActiveData.iva_ministero" name="iva_ministero" :change="aggiornaQuotaMinistero" />
                    </b-col>
                    <b-col xl="3" md="6" class="mb-2">
                      <label for="p_ministero" class="h5">% Applicazione Bilancio Ministero</label>
                      <ejs-numerictextbox id="p_ministero" ref="p_ministero" v-model="dettAssegnazioneActiveData.p_ministero"
                        floatLabelType="Never" cssClass="" format="###.##" placeholder="Percentuale applicazione Bilancio Ministero Entrate/Uscite"
                        showSpinButton="false" showClearButton="true" :min="min" :max="max" :step="step" :change="aggiornaQuotaMinistero" />
                    </b-col>
                    <b-col xl="4" md="6" class="mb-2">
                      <label for="quota_ministero" class="h5">Quota Ministero</label>
                      <ejs-numerictextbox id="quota_ministero" ref="quota_ministero" v-model="dettAssegnazioneActiveData.quota_ministero"
                        floatLabelType="Never" cssClass="" format="€ ###.##"
                        placeholder="Quota Ministero" showSpinButton="false" showClearButton="true" />
                    </b-col>
                  </b-row>
                  <b-row>
                    <b-col xl="3" md="6" class="mb-2">
                      <label for="cat_regione" class="h5">Categoria Bilancio Regione Entrate/Uscite</label>
                      <ejs-dropdownlist
                        id="cat_regione"
                        v-model="dettAssegnazioneActiveData.cat_regione"
                        :dataSource="cat_regioneList"
                        :fields="cat_regioneFields"
                        :allowFiltering="true"
                        showClearButton="true"
                        :change="resetPercRegione"
                      />
                    </b-col>
                    <b-col xl="2" md="4" class="mb-2">
                      <label for="iva_regione" class="h5 mr-2">IVA Regione</label>
                      <ejs-checkbox id="iva_regione" v-model="dettAssegnazioneActiveData.iva_regione" ref="iva_regione"
                        :checked="dettAssegnazioneActiveData.iva_regione" name="iva_regione" :change="aggiornaQuotaRegione" />
                    </b-col>
                    <b-col xl="3" md="6" class="mb-2">
                      <label for="p_regione" class="h5">% Applicazione Bilancio Regione</label>
                      <ejs-numerictextbox id="p_regione" ref="p_regione" v-model="dettAssegnazioneActiveData.p_regione"
                        floatLabelType="Never" cssClass="" format="###.##" placeholder="Percentuale applicazione Bilancio Regione Entrate/Uscite"
                        showSpinButton="false" showClearButton="true" :min="min" :max="max" :step="step" :change="aggiornaQuotaRegione" />
                    </b-col>
                    <b-col xl="4" md="6" class="mb-2">
                      <label for="quota_regione" class="h5">Quota Regione</label>
                      <ejs-numerictextbox id="quota_regione" ref="quota_regione" v-model="dettAssegnazioneActiveData.quota_regione"
                        floatLabelType="Never" cssClass="" format="€ ###.##"
                        placeholder="Quota Regione" showSpinButton="false" showClearButton="true" />
                    </b-col>
                  </b-row>
                </b-card-body>
              </b-card>
            </b-col>
          </b-row>
        </b-tab>
      </b-tabs>
    </ejs-dialog>


  </div>
</template>

<script>
import Vue from 'vue'
import useJwt from '@/auth/jwt/useJwt'
import {
  LayoutPlugin, TabsPlugin, CardPlugin, DropdownPlugin, ImagePlugin, EmbedPlugin, TablePlugin, LinkPlugin, AlertPlugin, ProgressPlugin, ToastPlugin, FormGroupPlugin, FormInputPlugin, FormCheckboxPlugin, FormSelectPlugin,
} from 'bootstrap-vue'
import { enableRipple } from '@syncfusion/ej2-base'
import { Query } from '@syncfusion/ej2-data';
import {
  DateTimePickerPlugin, DateRangePickerPlugin, DatePickerPlugin, TimePickerPlugin,
} from '@syncfusion/ej2-vue-calendars'
import { ButtonPlugin, CheckBoxPlugin, SwitchPlugin } from '@syncfusion/ej2-vue-buttons'
import {
  TextBoxPlugin, NumericTextBoxPlugin, MaskedTextBoxPlugin, 
} from '@syncfusion/ej2-vue-inputs'
import {
  DropDownListPlugin, MultiSelectPlugin, ListBoxPlugin, 
} from '@syncfusion/ej2-vue-dropdowns'
import { DialogPlugin } from '@syncfusion/ej2-vue-popups'
import {
  GridPlugin, Edit, Toolbar, Sort, Filter, Group, Aggregate, ForeignKey,
} from '@syncfusion/ej2-vue-grids'
import { DropDownButtonPlugin } from '@syncfusion/ej2-vue-splitbuttons'

const axios = require('axios')
// use bootstrap-vue
Vue.use(TabsPlugin)
Vue.use(CardPlugin)
Vue.use(LayoutPlugin)
Vue.use(DropdownPlugin)
Vue.use(ImagePlugin)
Vue.use(EmbedPlugin)
Vue.use(TablePlugin)
Vue.use(LinkPlugin)
Vue.use(AlertPlugin)
Vue.use(ProgressPlugin)
Vue.use(ToastPlugin)
Vue.use(FormGroupPlugin)
Vue.use(FormInputPlugin)
Vue.use(FormCheckboxPlugin)
Vue.use(FormSelectPlugin)
// use Syncfusion
Vue.use(TextBoxPlugin)
Vue.use(NumericTextBoxPlugin)
Vue.use(MaskedTextBoxPlugin)
Vue.use(DateRangePickerPlugin)
Vue.use(DatePickerPlugin)
Vue.use(DateTimePickerPlugin)
Vue.use(TimePickerPlugin)
Vue.use(DropDownListPlugin)
Vue.use(MultiSelectPlugin)
Vue.use(ButtonPlugin)
Vue.use(CheckBoxPlugin)
Vue.use(SwitchPlugin)
Vue.use(DialogPlugin)
Vue.use(GridPlugin)
Vue.use(DropDownButtonPlugin)
Vue.use(ListBoxPlugin)
enableRipple(true)
// api
const apiRegContabiliUrl = '/demo/api/pntesta' // prendere da pntesta
const apiRicercaPnRigConUrl = '/demo/api/pnrigcon/ricerca'
const apiDettaglioAssegnazioneUrl = '/demo/api/dettaglioassegnazione'


const nazioni = [
  { nazioniName: 'eu', nazioniId: 'eu' },
  { nazioniName: 'extraeu', nazioniId: 'extraeu' },
]

export default Vue.extend({
  components: {
  },
  data() {
    return {
      // generali
      min: 0,
      max: 100,
      step: 0.01,
      settings: {
        formatoData: 'dd/MM/yyyy',
        formatoOra: 'HH:mm',
        intervalloOra: 15,
        listboxSelectionSettings: { showCheckbox: true },
      },
      nazParams: {
        params: {
          allowFiltering: true,
          dataSource: nazioni,
          fields: { text: 'nazioniName', value: 'nazioniId' },
          query: new Query(),
          actionComplete: () => false,
        },
      },
      dataInizio: "01/01/2023",
      dataFine: "31/12/2023",
      // regContabili
      regContabiliFullData: [], // elenco completo dati produzioni
      regContabiliActiveId: 0, // Id Registrazione Contabile attivo (0 se nuovo)
      regContabiliActiveData: {}, // dati completi dell Registrazione Contabile attivo
      righeContabiliActiveData: {}, // dati completi dell Registrazione Contabile attivo
      regContabiliSavedData: {}, // dati completi dell Registrazione Contabile attivo
      // docProduzioni
      docRegContabiliFullData: [], // elenco completo dati documenti produzioni
      docRegContabiliActiveId: 0, // Id documento produzioni attivo (0 se nuovo)
      docRegContabiliActiveData: {}, // dati completi del documento produzioni attivo
      docRegContabiliDefaultData: {}, // dati completi di default per nuovi documenti produzioni
      // dettaglio assegnazione destinatari
      dettAssegnazioneActiveId: 0, // Id attivo (0 se nuovo)
      dettAssegnazioneActiveData: {}, // dati completi
      dettAssegnazioneDefaultData: {}, // dati completi di default


      // cat_ministeroList
      cat_ministeroList: [
      { label: "Contributi Statali (extra FUS)", id: "Contributi Statali (extra FUS)" },
      { label: "Contributi regionali", id: "Contributi regionali" },
      { label: "Contributi comunali", id: "Contributi comunali" },
      { label: "Contributi da UE", id: "Contributi da UE" },
      { label: "Contributi da altri enti pubblici", id: "Contributi da altri enti pubblici" },
      { label: "Contributi da soggetti privati", id: "Contributi da soggetti privati" },
      { label: "Sponsorizzazioni economiche", id: "Sponsorizzazioni economiche" },
      { label: "Rimborsi da coproduzione", id: "Rimborsi da coproduzione" },
      { label: "Altre entrate da coproduzione", id: "Altre entrate da coproduzione" },
      { label: "Entrate da abbonamenti", id: "Entrate da abbonamenti" },
      { label: "Incassi da biglietteria (produz. E co-prod)", id: "Incassi da biglietteria (produz. E co-prod)" },
      { label: "Incassi da biglietteria (ospitalità)", id: "Incassi da biglietteria (ospitalità)" },
      { label: "Incassi da prevendita", id: "Incassi da prevendita" },
      { label: "Entrate derivanti da compensi per attività", id: "Entrate derivanti da compensi per attività" },
      { label: "Altre entrate", id: "Altre entrate" },
      { label: "Entrate da servizi accessori (noli,bar,pubbicazioni, ecc)", id: "Entrate da servizi accessori (noli,bar,pubbicazioni, ecc)" },
      { label: "Altre entrate (es quote sociali)", id: "Altre entrate (es quote sociali)" },
      { label: "Oneri sociali direttore artistico carico A.", id: "Oneri sociali direttore artistico carico A." },
      { label: "Compenso direttore artistico", id: "Compenso direttore artistico" },
      { label: "Retribuzione lorda personale artistico", id: "Retribuzione lorda personale artistico" },
      { label: "Oneri sociali personale artistico carico A.", id: "Oneri sociali personale artistico carico A." },
      { label: "Retribuzione lorda personale tecnico", id: "Retribuzione lorda personale tecnico" },
      { label: "Oneri sociali personale tecnico carico A.", id: "Oneri sociali personale tecnico carico A." },
      { label: "Retribuzione lorda personale amm.vo", id: "Retribuzione lorda personale amm.vo" },
      { label: "Oneri sociali personale amm.vo carico A.", id: "Oneri sociali personale amm.vo carico A." },
      { label: "Diarie forfettarie", id: "Diarie forfettarie" },
      { label: "Compensi organismi ospitati", id: "Compensi organismi ospitati" },
      { label: "Costi viaggi, trasporto, alloggi C.O.", id: "Costi viaggi, trasporto, alloggi C.O." },
      { label: "Noleggi tecnici", id: "Noleggi tecnici" },
      { label: "Prestazioni di terzi x allestimenti(m/s/f)", id: "Prestazioni di terzi x allestimenti(m/s/f)" },
      { label: "SIAE Ospitalità", id: "SIAE Ospitalità" },
      { label: "VVF a carico azienda", id: "VVF a carico azienda" },
      { label: "Costi viaggi, trasporto, alloggi Produzioni", id: "Costi viaggi, trasporto, alloggi Produzioni" },
      { label: "Acquisti scene, costumi,strumenti ecc", id: "Acquisti scene, costumi,strumenti ecc" },
      { label: "Noleggi scene, costumi,strumenti ecc", id: "Noleggi scene, costumi,strumenti ecc" },
      { label: "Acquisti strumentazione tecnica non amm.", id: "Acquisti strumentazione tecnica non amm." },
      { label: "Noleggi strumentazione tecnica", id: "Noleggi strumentazione tecnica" },
      { label: "Affitto sala prove", id: "Affitto sala prove" },
      { label: "Prestazioni di terzi x allestimenti(m/s/f)", id: "Prestazioni di terzi x allestimenti(m/s/f)" },
      { label: "SIAE Produzioni", id: "SIAE Produzioni" },
      { label: "VVF a carico azienda", id: "VVF a carico azienda" },
      { label: "Ufficio stampa e comunicazione", id: "Ufficio stampa e comunicazione" },
      { label: "Costi stampe,distrib. E affissione", id: "Costi stampe,distrib. E affissione" },
      { label: "Costi per prestazioni (registr., video, audio, foto)", id: "Costi per prestazioni (registr., video, audio, foto)" },
      { label: "Costi per pubblicità", id: "Costi per pubblicità" },
      { label: "Costi gestione e man.ne sito web", id: "Costi gestione e man.ne sito web" },
      { label: "Affitto spazi per spettacoli", id: "Affitto spazi per spettacoli" },
      { label: "Costi di manutenzione ordinaria spazi", id: "Costi di manutenzione ordinaria spazi" },
      { label: "Utenze", id: "Utenze" },
      { label: "Pulizie Gestione Spazi", id: "Pulizie Gestione Spazi" },
      { label: "Quota amm.to scene/costumi", id: "Quota amm.to scene/costumi" },
      { label: "Quota amm.to strumentazione tecnica", id: "Quota amm.to strumentazione tecnica" },
      { label: "Materiale di consumo", id: "Materiale di consumo" },
      { label: "Altre prestazioni Professionali (commercialista, consulente lavoro, avvocato, RSPP ecc)", id: "Altre prestazioni Professionali (commercialista, consulente lavoro, avvocato, RSPP ecc)" },
      { label: "Utenze uffici", id: "Utenze uffici" },
      { label: "Assicurazioni", id: "Assicurazioni" },
      { label: "Pulizie Generali", id: "Pulizie Generali" },
      { label: "Altri costi Generali (Diritti ecc)", id: "Altri costi Generali (Diritti ecc)" },
      { label: "Costi tutela sanitaria", id: "Costi tutela sanitaria" },
      ],
      cat_ministeroFields: { text: "label", value: "id" },

      // cat_teatroCocciaList
      cat_teatroCocciaList: [
      { label: "RICAVI BIGLIETTERIA PRODUZIONI", id: "RICAVI BIGLIETTERIA PRODUZIONI" },
      { label: "RICAVI PER COPRODUZIONI SPETTACOLI", id: "RICAVI PER COPRODUZIONI SPETTACOLI" },
      { label: "RICAVI ATTIVITA' CULTURALI", id: "RICAVI ATTIVITA' CULTURALI" },
      { label: "RICAVI PER ACCADEMIA - CANTO E DIREZIONE", id: "RICAVI PER ACCADEMIA - CANTO E DIREZIONE" },
      { label: "RICAVI DA PRESTAZONI DI SERVIZI", id: "RICAVI DA PRESTAZONI DI SERVIZI" },
      { label: "NOLEGGIO ATTIVO IMPIANTI E MACCHINARI (GESTIONE TIPICA)", id: "NOLEGGIO ATTIVO IMPIANTI E MACCHINARI (GESTIONE TIPICA)" },
      { label: "RICAVI DA SPONSOR", id: "RICAVI DA SPONSOR" },
      { label: "RICAVI ALLESTIMENTO MOSTRE", id: "RICAVI ALLESTIMENTO MOSTRE" },
      { label: "RICAVI DA PROGETTI", id: "RICAVI DA PROGETTI" },
      { label: "AFFITTI ATTIVI", id: "AFFITTI ATTIVI" },
      { label: "SOPRAVVENIENZE ATTIVE ORDINARIE", id: "SOPRAVVENIENZE ATTIVE ORDINARIE" },
      { label: "RIMBORSO SPESE VIGILI DEL FUOCO", id: "RIMBORSO SPESE VIGILI DEL FUOCO" },
      { label: "RIMBORSO SPESE ANTICIPATE", id: "RIMBORSO SPESE ANTICIPATE" },
      { label: "CONTRIBUTI IN C/ESERCIZIO", id: "CONTRIBUTI IN C/ESERCIZIO" },
      { label: "CONTRIBUTI IN C/CAPITALE", id: "CONTRIBUTI IN C/CAPITALE" },
      { label: "ALTRI CONTRIBUTI", id: "ALTRI CONTRIBUTI" },
      { label: "CONTROLLO DI GESTIONE S.PAOLO", id: "CONTROLLO DI GESTIONE S.PAOLO" },
      { label: "CONTRIB.DA MINISTERO PER VIGILANZA", id: "CONTRIB.DA MINISTERO PER VIGILANZA" },
      { label: "CONTRIBUTI ART BONUS", id: "CONTRIBUTI ART BONUS" },
      { label: "PROVENTI DA DONAZIONI", id: "PROVENTI DA DONAZIONI" },
      { label: "ACQUISTI MATERIALI PER SCENE", id: "ACQUISTI MATERIALI PER SCENE" },
      { label: "ACQUISTI MATERIALE DI CONSUMO", id: "ACQUISTI MATERIALE DI CONSUMO" },
      { label: "DISPOSITIVI DI PROTEZIONE COVID19", id: "DISPOSITIVI DI PROTEZIONE COVID19" },
      { label: "ACQUISTO STAMPATI AMMINISTRATIVI", id: "ACQUISTO STAMPATI AMMINISTRATIVI" },
      { label: "ATTREZZATURA <516 EURO DA NON AMM.RE", id: "ATTREZZATURA <516 EURO DA NON AMM.RE" },
      { label: "CARBURANTI E LUBRIFICANTI PER MEZZI DI TRASPORTO", id: "CARBURANTI E LUBRIFICANTI PER MEZZI DI TRASPORTO" },
      { label: "ACQUISTO MATERIALE PUBBLICITARIO", id: "ACQUISTO MATERIALE PUBBLICITARIO" },
      { label: "CANCELLERIA", id: "CANCELLERIA" },
      { label: "CARBURANTI E LUBRIFICANTI", id: "CARBURANTI E LUBRIFICANTI" },
      { label: "INDUMENTI DI LAVORO E VESTIARIO-covid", id: "INDUMENTI DI LAVORO E VESTIARIO-covid" },
      { label: "MATERIALE DI PULIZIA", id: "MATERIALE DI PULIZIA" },
      { label: "ACQUISTO DI FARMACI", id: "ACQUISTO DI FARMACI" },
      { label: "SPESE VITTO, ALLOGGIO, OMAGGI DEDUCIBILI L. 244/2007", id: "SPESE VITTO, ALLOGGIO, OMAGGI DEDUCIBILI L. 244/2007" },
      { label: "SPESE ISCRIZIONE A MASTER, CORSI FORMAZIONE O AGGIORNAMENTO", id: "SPESE ISCRIZIONE A MASTER, CORSI FORMAZIONE O AGGIORNAMENTO" },
      { label: "SPESE DI VIAGGIO E TRASFERTA DIPENDENTI", id: "SPESE DI VIAGGIO E TRASFERTA DIPENDENTI" },
      { label: "OPERE E SERVIZI PER LA GENERALITA' DEI DIPENDENTI", id: "OPERE E SERVIZI PER LA GENERALITA' DEI DIPENDENTI" },
      { label: "PEDAGGI AUTOSTRADALI", id: "PEDAGGI AUTOSTRADALI" },
      { label: "SPESE DI PUBBLICITA' E PROPAGANDA", id: "SPESE DI PUBBLICITA' E PROPAGANDA" },
      { label: "TRASPORTI SU ACQUISTI", id: "TRASPORTI SU ACQUISTI" },
      { label: "ONERI VARI SU ACQUISTI", id: "ONERI VARI SU ACQUISTI" },
      { label: "ENERGIA ELETTRICA", id: "ENERGIA ELETTRICA" },
      { label: "CONSULENZE TECNICHE", id: "CONSULENZE TECNICHE" },
      { label: "SERVIZI VIGILANZA ANTINCENDIO", id: "SERVIZI VIGILANZA ANTINCENDIO" },
      { label: "MANUTENZIONE FABBRICATI", id: "MANUTENZIONE FABBRICATI" },
      { label: "MANUTENZIONE MACCHINARI", id: "MANUTENZIONE MACCHINARI" },
      { label: "MANUTENZIONI E RIPARAZIONI AUTOMEZZI", id: "MANUTENZIONI E RIPARAZIONI AUTOMEZZI" },
      { label: "NUOVE MANUTENZIONI", id: "NUOVE MANUTENZIONI" },
      { label: "SPESE PER TRASPORTI SU VENDITE", id: "SPESE PER TRASPORTI SU VENDITE" },
      { label: "SPESE DI RAPPRESENTANZA", id: "SPESE DI RAPPRESENTANZA" },
      { label: "ASSICURAZIONI DIVERSE NON OBBLIGATORIE", id: "ASSICURAZIONI DIVERSE NON OBBLIGATORIE" },
      { label: "SPESE PER SERVIZI POSTALI", id: "SPESE PER SERVIZI POSTALI" },
      { label: "SERVIZI DI PULIZIA", id: "SERVIZI DI PULIZIA" },
      { label: "SERVIZI VARI AMMINISTRATIVI", id: "SERVIZI VARI AMMINISTRATIVI" },
      { label: "ACQUA", id: "ACQUA" },
      { label: "SPESE FORMAZIONE ANTINCENDIO E PRONTO SOCCORSO", id: "SPESE FORMAZIONE ANTINCENDIO E PRONTO SOCCORSO" },
      { label: "CONSULENZE PROFESSIONALI", id: "CONSULENZE PROFESSIONALI" },
      { label: "CONSULENZE AMMINISTRATIVE E LEGALI", id: "CONSULENZE AMMINISTRATIVE E LEGALI" },
      { label: "TELEFONICHE DEDUCIBILI 80%", id: "TELEFONICHE DEDUCIBILI 80%" },
      { label: "SERVIZI DI VIGILANZA", id: "SERVIZI DI VIGILANZA" },
      { label: "PREMIO CANTELLI", id: "PREMIO CANTELLI" },
      { label: "COLLABORAZIONE COORD. E CONTIN. NON AFFERENTI", id: "COLLABORAZIONE COORD. E CONTIN. NON AFFERENTI" },
      { label: "SPESE ELABORAZIONE PAGHE", id: "SPESE ELABORAZIONE PAGHE" },
      { label: "CONSULENZE PROF.LI AFFER. L'ATTIVITA'", id: "CONSULENZE PROF.LI AFFER. L'ATTIVITA'" },
      { label: "MANUTENZIONI E RIPARAZIONI", id: "MANUTENZIONI E RIPARAZIONI" },
      { label: "RISCALDAMENTO", id: "RISCALDAMENTO" },
      { label: "ALBERGHI E RISTORANTI DED. 100%", id: "ALBERGHI E RISTORANTI DED. 100%" },
      { label: "SERVIZI BANCARI", id: "SERVIZI BANCARI" },
      { label: "COSTI PER SERVIZI SU RIFIUTI", id: "COSTI PER SERVIZI SU RIFIUTI" },
      { label: "SPESE DI PROMOZIONE", id: "SPESE DI PROMOZIONE" },
      { label: "MANUTENZIONI A CONTRATTO", id: "MANUTENZIONI A CONTRATTO" },
      { label: "SPESE CERTIFICAZIONE QUALITA'", id: "SPESE CERTIFICAZIONE QUALITA'" },
      { label: "SERVIZI VARI GENERALI", id: "SERVIZI VARI GENERALI" },
      { label: "CANONI DI MANUTENZIONE", id: "CANONI DI MANUTENZIONE" },
      { label: "MANUTENZIONE STRAORDINARIA BENI TERZI", id: "MANUTENZIONE STRAORDINARIA BENI TERZI" },
      { label: "SPESE PER PRESTAZIONI MEDICHE", id: "SPESE PER PRESTAZIONI MEDICHE" },
      { label: "ASSICURAZIONI DIVERSE OBBLIGATORIE", id: "ASSICURAZIONI DIVERSE OBBLIGATORIE" },
      { label: "CANONI ASSISTENZA SOFTWARE", id: "CANONI ASSISTENZA SOFTWARE" },
      { label: "SERVIZI RELATIVI A INTERNET", id: "SERVIZI RELATIVI A INTERNET" },
      { label: "VIAGGIO E TRASFERTE COLLABORATORI DEDUCIBILI", id: "VIAGGIO E TRASFERTE COLLABORATORI DEDUCIBILI" },
      { label: "SCENE", id: "SCENE" },
      { label: "COSTUMI", id: "COSTUMI" },
      { label: "CORO", id: "CORO" },
      { label: "ORCHESTRA", id: "ORCHESTRA" },
      { label: "TRASPORTI", id: "TRASPORTI" },
      { label: "COLLABORATORI PROFESSIONISTI TECNICI", id: "COLLABORATORI PROFESSIONISTI TECNICI" },
      { label: "COLLABORATORI ARTISTICI", id: "COLLABORATORI ARTISTICI" },
      { label: "COSTO MUSICISTI E ORCHESTRE", id: "COSTO MUSICISTI E ORCHESTRE" },
      { label: "COSTO BALLETTO", id: "COSTO BALLETTO" },
      { label: "ALLESTIMENTI - TRUCCO E PARRUCCO", id: "ALLESTIMENTI - TRUCCO E PARRUCCO" },
      { label: "NOLO PARTITURE", id: "NOLO PARTITURE" },
      { label: "VITTO E ALLOGGIO ARTISTI", id: "VITTO E ALLOGGIO ARTISTI" },
      { label: "MATERIALE PUBBLICITARIO", id: "MATERIALE PUBBLICITARIO" },
      { label: "CACHET COMPAGNIE OSPITI", id: "CACHET COMPAGNIE OSPITI" },
      { label: "FACCHINAGGI", id: "FACCHINAGGI" },
      { label: "COPRODUZIONI", id: "COPRODUZIONI" },
      { label: "COSTI ACCADEMIA AMO", id: "COSTI ACCADEMIA AMO" },
      { label: "ONERI SU DIREZIONE ARTISTICA", id: "ONERI SU DIREZIONE ARTISTICA" },
      { label: "ALTRI COSTI PER COMPAGNIE OSPITI", id: "ALTRI COSTI PER COMPAGNIE OSPITI" },
      { label: "AMMINISTRATIVE - ACCADEMIA AMO", id: "AMMINISTRATIVE - ACCADEMIA AMO" },
      { label: "LAVORI RESTAURO CONSERVATIVO - ACCADEMIA AMO", id: "LAVORI RESTAURO CONSERVATIVO - ACCADEMIA AMO" },
      { label: "PROMOZIONE ACCADEMIA AMO", id: "PROMOZIONE ACCADEMIA AMO" },
      { label: "NOLEGGIO SCENE E COSTUMI", id: "NOLEGGIO SCENE E COSTUMI" },
      { label: "NOLEGGIO MATERIALE TECNICO", id: "NOLEGGIO MATERIALE TECNICO" },
      { label: "AFFITTI E LOCAZIONI PASSIVE IMMOBILI", id: "AFFITTI E LOCAZIONI PASSIVE IMMOBILI" },
      { label: "NOLEGGIO AUTOMEZZI", id: "NOLEGGIO AUTOMEZZI" },
      { label: "CANONI LEASING MACCHINARI", id: "CANONI LEASING MACCHINARI" },
      { label: "DIRITTI E ROYALTIES", id: "DIRITTI E ROYALTIES" },
      { label: "DIRITTI E ROYALTIES COMPAGNIE OSPITI", id: "DIRITTI E ROYALTIES COMPAGNIE OSPITI" },
      { label: "SALARI IMPIEGATI TECNICI", id: "SALARI IMPIEGATI TECNICI" },
      { label: "CONTRIBUTI PREVIDENZIALI IMPIEGATI TECNICI", id: "CONTRIBUTI PREVIDENZIALI IMPIEGATI TECNICI" },
      { label: "CONTRIBUTI ENPALS ARTISTI", id: "CONTRIBUTI ENPALS ARTISTI" },
      { label: "CONTRIBUTI INAIL", id: "CONTRIBUTI INAIL" },
      { label: "ACCANTONAMENTO T.F.R.", id: "ACCANTONAMENTO T.F.R." },
      { label: "AMM.CONCESSIONI", id: "AMM.CONCESSIONI" },
      { label: "AMMORTAMENTO MANUTENZ.STRAORDINARIE", id: "AMMORTAMENTO MANUTENZ.STRAORDINARIE" },
      { label: "AMM. ALTRI BENI IMMATERIALI", id: "AMM. ALTRI BENI IMMATERIALI" },
      { label: "AMMORTAMENTO BENI MATERIALI", id: "AMMORTAMENTO BENI MATERIALI" },
      { label: "ACCANTONAMENTO SVALUTAZIONE CREDITI", id: "ACCANTONAMENTO SVALUTAZIONE CREDITI" },
      { label: "ACCANTONAMENTO FONDO RISCHI", id: "ACCANTONAMENTO FONDO RISCHI" },
      { label: "AMMENDE E MULTE INDEDUCIBILI", id: "AMMENDE E MULTE INDEDUCIBILI" },
      { label: "IMPOSTE E TASSE INDEDUCIBILI", id: "IMPOSTE E TASSE INDEDUCIBILI" },
      { label: "IMU", id: "IMU" },
      { label: "IMPOSTA DI REGISTRO", id: "IMPOSTA DI REGISTRO" },
      { label: "TARI", id: "TARI" },
      { label: "SOPRAVVENIENZE PASSIVE ORDINARIE", id: "SOPRAVVENIENZE PASSIVE ORDINARIE" },
      { label: "BOLLI AUTOMEZZI", id: "BOLLI AUTOMEZZI" },
      { label: "BOLLI E VALORI BOLLATI", id: "BOLLI E VALORI BOLLATI" },
      { label: "LIBRI E GIORNALI", id: "LIBRI E GIORNALI" },
      { label: "CONTRIBUTI ASSOCIATIVI", id: "CONTRIBUTI ASSOCIATIVI" },
      { label: "DIRITTI SIAE", id: "DIRITTI SIAE" },
      { label: "QUOTE ASSOCIATIVE", id: "QUOTE ASSOCIATIVE" },
      { label: "SANZIONI TRIBUTARIE DA RAVVED. OPEROSO INDEDUCIBILI", id: "SANZIONI TRIBUTARIE DA RAVVED. OPEROSO INDEDUCIBILI" },
      { label: "INTERESSI ATTIVI DA BANCHE", id: "INTERESSI ATTIVI DA BANCHE" },
      { label: "ABBUONI ATTIVI FINANZIARI", id: "ABBUONI ATTIVI FINANZIARI" },
      { label: "ONERI BANCARI FINANZIARI", id: "ONERI BANCARI FINANZIARI" },
      { label: "INTERESSI PASSIVI SU ANTICIPI", id: "INTERESSI PASSIVI SU ANTICIPI" },
      { label: "INTERESSI PASSIVI SU MUTUI", id: "INTERESSI PASSIVI SU MUTUI" },
      { label: "INTERESSI PASSIVI VERSO FORNITORI", id: "INTERESSI PASSIVI VERSO FORNITORI" },
      { label: "INTERESSI PASSIVI A ENTI PREV. NON DED.", id: "INTERESSI PASSIVI A ENTI PREV. NON DED." },
      { label: "INTERESSI PASSIVI A ENTI PREVIDENZIALI INDEDUCIBILI", id: "INTERESSI PASSIVI A ENTI PREVIDENZIALI INDEDUCIBILI" },
      { label: "ABBUONI PASSIVI FINANZIARI", id: "ABBUONI PASSIVI FINANZIARI" },
      { label: "INTERESSI PASSIVI SU RAVVEDIMENTO OPEROSO", id: "INTERESSI PASSIVI SU RAVVEDIMENTO OPEROSO" },
      { label: "INTERESSI PASSIVI IMPOSTE", id: "INTERESSI PASSIVI IMPOSTE" },
      { label: "IRES ESERCIZIO", id: "IRES ESERCIZIO" },
      { label: "IRAP ESERCIZIO", id: "IRAP ESERCIZIO" },
      
      ],
      cat_teatroCocciaFields: { text: "label", value: "id" },

      // cat_regioneList
      cat_regioneList: [
      { label: "Direzione artistica", id: "Direzione artistica" },
      { label: "Cachets degli artisti", id: "Cachets degli artisti" },
      { label: "Compensi e relativi oneri fiscali, previdenziali, assistenziali ai collaboratori esclusivamente impegnati nelle attività di spettacolo", id: "Compensi e relativi oneri fiscali, previdenziali, assistenziali ai collaboratori esclusivamente impegnati nelle attività di spettacolo" },
      { label: "Compensi e relativi oneri fiscali, previdenziali, assistenziali al personale tecnico", id: "Compensi e relativi oneri fiscali, previdenziali, assistenziali al personale tecnico" },
      { label: "Compensi e relativi oneri fiscali, previdenziali, assistenziali a relatori e docenti", id: "Compensi e relativi oneri fiscali, previdenziali, assistenziali a relatori e docenti" },
      { label: "...", id: "..." },
      
      ],
      cat_regioneFields: { text: "label", value: "id" },

      // per alertA
      alertADismissSecs: 3,
      alertADismissCountDown: 0,

      // per dialogA1
      dialogA1: {
        header: '',
        visible: false,
        showCloseIcon: true,
        buttons: [{ click: this.dialogA1Ok, buttonModel: { content: 'OK', isPrimary: true } },
        { click: this.dialogA1Cancel, buttonModel: { content: 'Cancel' } }],
        animationSettings: { effect: 'FadeZoom', duration: 400, delay: 0 }, // { effect: 'None' }, // selezionata per primo livello
        zIndex: 1050,
        tabAdialogA1Index: 0,
        isVisible: null, // per controllare eventi onXXchange
      },
      // per gridA
      gridAFlag: false,
      gridA: {
        height: 400,
        editOptions: {
          allowEditing: false,
          allowDeleting: false,
        },
        filterOptions: { type: 'Excel' },
        //groupOptions: { showDropArea: false, columns: ['cat_ministero'] },
        groupOptions: {showDropArea: false },
        toolbarOptions: [
          // {
          //   text: 'Nuova Registrazione Contabile', tooltipText: 'Inserisci nuovo Registrazione Contabile', prefixIcon: 'e-plus', id: 'newRC',
          // },
          {
            text: 'Apri Registrazione Contabile', tooltipText: 'Modifica Registrazione Contabile', prefixIcon: 'e-expand', id: 'edit',
          },
          // {
          //   text: 'Cancella Registrazione Contabile', tooltipText: 'Cancella Registrazione Contabile', prefixIcon: 'e-cancel', id: 'delete',
          // },
          'Search',
        ],
      }, //
      // per gridB
      gridBFlag: false,
      gridB: {
        height: 300,
        editOptions: {
          allowEditing: false,
          allowDeleting: false,
        },
        filterOptions: { type: 'Excel' },
        toolbarOptions: [
          // {
          //   text: 'Nuova Registrazione Contabile', tooltipText: 'Inserisci nuovo Registrazione Contabile', prefixIcon: 'e-plus', id: 'newRC',
          // },
          // {
          //   text: 'Apri Registrazione Contabile', tooltipText: 'Modifica Registrazione Contabile', prefixIcon: 'e-expand', id: 'edit',
          // },
          // {
          //   text: 'Cancella Registrazione Contabile', tooltipText: 'Cancella Registrazione Contabile', prefixIcon: 'e-cancel', id: 'delete',
          // },
          'Search',
        ],
      },
    }
  },
  created() {
    console.log('Pagina Registrazioni Contabili creata')
    // inizializzazione elenchi dal backend
    // chiamate API
  },

  provide: {
    grid: [Toolbar, Sort, Filter, Edit, Group, Aggregate, ForeignKey],
  },
  methods: {
    noop() {
      console.log("premuto enter");
    },
    roundNumber: function(val) {
      return Math.round(val * 100) / 100;
    },
    resetPercTeatroCoccia: function () {
      if (this.dialogA1.isVisible == true) {
        if (this.dettAssegnazioneActiveData.cat_teatroCoccia == null) {
          console.log("Reset percentuale TeatroCoccia");
          this.dettAssegnazioneActiveData.p_teatroCoccia = 0;
          this.$refs.p_teatroCoccia.ej2Instances.value = this.dettAssegnazioneActiveData.p_teatroCoccia
          this.$refs.p_teatroCoccia.dataBind()
        }
      }
    },
    aggiornaQuotaTeatroCoccia: function () {
      if (this.dialogA1.isVisible == true) {
        console.log("Aggiornamento Quota TeatroCoccia");
        if (this.dettAssegnazioneActiveData.iva_teatroCoccia == true) {
          this.dettAssegnazioneActiveData.quota_teatroCoccia = this.roundNumber(this.regContabiliActiveData.importototale_lordo * this.dettAssegnazioneActiveData.p_teatroCoccia / 100);
        } else {
          this.dettAssegnazioneActiveData.quota_teatroCoccia = this.roundNumber((this.regContabiliActiveData.importototale_lordo - this.regContabiliActiveData.ivatotale) * this.dettAssegnazioneActiveData.p_teatroCoccia / 100);
        }
        this.$refs.quota_teatroCoccia.ej2Instances.value = this.dettAssegnazioneActiveData.quota_teatroCoccia
        this.$refs.quota_teatroCoccia.dataBind()
      }
    },
    resetPercMinistero: function () {
      if (this.dialogA1.isVisible == true) {
        if (this.dettAssegnazioneActiveData.cat_ministero == null) {
          console.log("Reset percentuale Ministero");
          this.dettAssegnazioneActiveData.p_ministero = 0;
          this.$refs.p_ministero.ej2Instances.value = this.dettAssegnazioneActiveData.p_ministero
          this.$refs.p_ministero.dataBind()
        }
      }
    },
    aggiornaQuotaMinistero: function () {
      if (this.dialogA1.isVisible == true) {
        console.log("Aggiornamento Quota Ministero");
        if (this.dettAssegnazioneActiveData.iva_ministero == true) {
          this.dettAssegnazioneActiveData.quota_ministero = this.roundNumber(this.regContabiliActiveData.importototale_lordo * this.dettAssegnazioneActiveData.p_ministero / 100);
        } else {
          this.dettAssegnazioneActiveData.quota_ministero = this.roundNumber((this.regContabiliActiveData.importototale_lordo - this.regContabiliActiveData.ivatotale) * this.dettAssegnazioneActiveData.p_ministero / 100);
        }
        this.$refs.quota_ministero.ej2Instances.value = this.dettAssegnazioneActiveData.quota_ministero
        this.$refs.quota_ministero.dataBind()
      }
    },
    resetPercRegione: function () {
      if (this.dialogA1.isVisible == true) {
        if (this.dettAssegnazioneActiveData.cat_regione == null) {
          console.log("Reset percentuale Regione");
          this.dettAssegnazioneActiveData.p_regione = 0;
          this.$refs.p_regione.ej2Instances.value = this.dettAssegnazioneActiveData.p_regione
          this.$refs.p_regione.dataBind()
        }
      }
    },
    aggiornaQuotaRegione: function () {
      if (this.dialogA1.isVisible == true) {
        console.log("Aggiornamento Quota Regione");
        if (this.dettAssegnazioneActiveData.iva_regione == true) {
          this.dettAssegnazioneActiveData.quota_regione = this.roundNumber(this.regContabiliActiveData.importototale_lordo * this.dettAssegnazioneActiveData.p_regione / 100);
        } else {
          this.dettAssegnazioneActiveData.quota_regione = this.roundNumber((this.regContabiliActiveData.importototale_lordo - this.regContabiliActiveData.ivatotale) * this.dettAssegnazioneActiveData.p_regione / 100);
        }
        this.$refs.quota_regione.ej2Instances.value = this.dettAssegnazioneActiveData.quota_regione
        this.$refs.quota_regione.dataBind()
      }
    },
    cercaRegistrazioni() {
      const apiRicerca = apiRegContabiliUrl + '/ricercaintervallo'
      const datiDaInviare = {
        'datainizio': this.dataInizio,
        'datafine': this.dataFine,
      }
      useJwt.post(apiRicerca, datiDaInviare).then((d) => {
        // gestione risposta
        if (d.status === 200) {
          //console.log(d.data)
          this.regContabiliFullData = d.data
          this.regContabiliFullData.forEach(function(element, index, theArray) {
            const data = element.dataregistrazione
            const giorno = parseInt(data.substring(0,2))
            const mese = parseInt(data.substring(2,4))
            const anno = parseInt(data.substring(4,8))
            const dataNuova = new Date(anno, mese - 1, giorno)
            theArray[index].dataregistrazione = dataNuova.toLocaleDateString('it-IT')
            //theArray[index].cat_ministero = element.dettaglioassegnazionedestinatari[0]['cat_ministero']
            //theArray[index].quota_ministero = element.dettaglioassegnazionedestinatari[0]['quota_ministero']
            //theArray[index].p_ministero = element.dettaglioassegnazionedestinatari[0]['p_ministero']
          })
          // console.log("REG CONTABILI")
          // console.log(this.regContabiliFullData)
        } else {
          console.log("FALLITO")
        }
      })
    },
    // per dialogA1
    dialogA1OpenButtonClick() {
      this.$refs.dialogA1.show(true)
    },
    dialogA1Open() {
      console.log('Apertura dialogA1')
      // controlla eventi onXXchange
      this.dialogA1.isVisible = true;
      // assegnare le informazioni da visualizzare nel dialog A
      console.log('Registrazione Contabile attivo')
      console.log(this.regContabiliActiveId)
      const apiRicerca = apiDettaglioAssegnazioneUrl + '/ricerca'
      const datiDaInviare = { pntesta_id: this.regContabiliActiveId, }

      useJwt.post(apiRicerca, datiDaInviare).then((d) => {
        // gestione risposta
        if (d.status === 200) {
          console.log(d.data)
          this.dettAssegnazioneActiveData = d.data
        } else {
          console.log('Dettagli assegnazione non trovati')
          this.dettAssegnazioneActiveData = {}
          this.dettAssegnazioneActiveData.commenti = ''
          this.dettAssegnazioneActiveData.cat_teatroCoccia = null
          this.dettAssegnazioneActiveData.cat_ministero = null
          this.dettAssegnazioneActiveData.cat_regione = null
          this.dettAssegnazioneActiveData.p_teatroCoccia = 0
          this.dettAssegnazioneActiveData.p_ministero = 0
          this.dettAssegnazioneActiveData.p_regione = 0
          this.dettAssegnazioneActiveData.iva_teatroCoccia = true
          this.dettAssegnazioneActiveData.iva_ministero = true
          this.dettAssegnazioneActiveData.iva_regione = true
          this.dettAssegnazioneActiveData.quota_teatroCoccia = 0
          this.dettAssegnazioneActiveData.quota_ministero = 0
          this.dettAssegnazioneActiveData.quota_regione = 0
        }
      });

      this.regContabiliSavedData = { ...this.regContabiliActiveData }

      // evita chiusura dialog su pressione enter
      let dialogObj = args.element.ej2_instances[0];
      dialogObj.keyDown = this.noop.bind(this);
      dialogObj.dataBind();

    },
    dialogA1Close() {
      console.log('Chiusura dialogA1')
      this.dialogA1.isVisible = false;
      this.dialogA1.tabAdialogA1Index = 0
      this.regContabiliActiveData.documenti = []
    },
    dialogA1Ok() {
      console.log('Cliccato bottone OK di dialogA1')
      // salvataggio informazioni in remoto
      const apiSalva = apiDettaglioAssegnazioneUrl + '/salva'
      this.dettAssegnazioneActiveData.pntesta_id = this.regContabiliActiveId;
      useJwt.post(apiSalva, this.dettAssegnazioneActiveData).then((d) => {
        // gestione risposta
        console.log(d.data)
        this.makeToast(
          "primary",
          "Successo",
          "Salvataggio completato con successo"
        );
      });

      this.$refs.dialogA1.hide()
    },
    dialogA1Cancel() {
      console.log('Cliccato bottone Cancel di dialogA1')
      this.$refs.dialogA1.hide()
    },
    // per gridA
    gridAClickHandler(args) {
      // pulsante EDIT
      if (args.item.id === 'edit') {
        this.dialogA1.header = 'Dettaglio Registrazione Contabile'
        console.log('Premuto pulsante modifica Registrazione Contabile da gridA')
        try {
          const selectedRow = this.$refs.gridA.getSelectedRecords()
          this.regContabiliActiveId = selectedRow[0].codiceunivocodiscaricamento
          console.log("gridA, Id selezionato:");
          console.log(this.regContabiliActiveId)
          // richiedere a backend righe contabili dato codiceunivocodiscaricamento
          useJwt.post(apiRicercaPnRigConUrl, {codice: this.regContabiliActiveId}).then(res => {
            console.log(res.status)
            console.log(res.data)
            this.righeContabiliActiveData = res.data
          })
          // console.log("TMP righeContabiliActiveData")
          // console.log(this.righeContabiliActiveData)

          this.regContabiliActiveData = this.regContabiliFullData.find((el) => (el.codiceunivocodiscaricamento === this.regContabiliActiveId))
          console.log("TMP regContabiliActiveData")
          console.log(this.regContabiliActiveData)
          this.$refs.dialogA1.show(true)
        } catch (err) {
          console.log('Occorre selezionare una riga della tabella')
          this.alertAShow()
        }
      }
      // Pulsante DELETE
      else if (args.item.id === 'delete') {
        try {
          console.log('Premuto pulsante elimina Registrazione Contabile da gridA')
          const selectedRow = this.$refs.gridA.getSelectedRecords()
          const deletedElementId = selectedRow[0].id

          const deleteUrl = `${apiRegContabiliUrl}/${deletedElementId}`
          this.$refs.gridA.ej2Instances.deleteRecord()

          useJwt.delete(deleteUrl).then(res => {
            console.log('Eliminazione avvenuta con successo')
            // console.log(res.data)
          })
        } catch (err) {
          // da sistemare..............
          console.log(err)
          console.log('Occorre selezionare una riga della tabella')
          this.alertAShow()
        }
      }
    },
    gridAactionBegin(e) {
      if (!this.gridAFlag) {
        // Add and edit operations
        if (e.requestType === 'save') {
          const editedData = e.data
          console.log(editedData)
          // The default edit operation is cancelled
          e.cancel = true
          const editUrl = `${apiRegContabiliUrl}/${editedData.id}`
          useJwt.patch(editUrl, editedData).then(res => {
            console.log(res)
            if (res.status === 200) {
              // se tutto OK
              // Flag is enabled to skip this execution when grid ends add/edit
              this.gridAFlag = true
              // If your data is updated at the server side successfully, we can call the grid endEdit() method to save the edited data to the Grid
              this.$refs.gridA.endEdit()
            } else {
              this.makeToast('primary', 'Attenzione', 'Salvataggio Registrazione Contabile non riuscito')
            }
          })
        }
      }
    },
    // Grid’s actionComplete event handler
    // Triggers after an action is completed
    gridAactionComplete(e) {
      if (e.requestType === 'save') {
        // The flag is disabled after operation is successfully performed so that it can enter the condition on next execution
        this.gridAFlag = false
      }
    },

    // per click tabs
    tabClicked(args) {
      switch (args) {
        case 'dialogA1Tab01':
          console.log('Sei nel primo tab del dialogA1')
          break
        case 'dialogA1Tab02':
          console.log('Sei nel secondo tab del dialogA1')
          break
        default:
          console.log(args)
      }
    },

    // per alert
    alertACountDownChanged(alertADismissCountDown) {
      this.alertADismissCountDown = alertADismissCountDown
    },
    alertAShow() {
      this.alertADismissCountDown = this.alertADismissSecs
    },
    // per toast
    makeToast(variant = null, title = 'titolo', message = 'messaggio') {
      this.$bvToast.toast(message, {
        title,
        variant,
        solid: true,
        autoHideDelay: 10000,
      })
    },
    // per file upload: ?? Serve differenziarli nei vari elementi fileUpload??
    addJWTHeaders(args) {
      const token = useJwt.getToken()

      useJwt.check() // qui dovrei restituire una promise per poter aspettare che venga risolta?
      args.currentRequest.setRequestHeader('Authorization', `Bearer ${token}`)
    },
    onFileUpload(args) {
      const token = useJwt.getToken()

      useJwt.check() // qui dovrei restituire una promise per poter aspettare che venga risolta?
      args.currentRequest.setRequestHeader('Authorization', `Bearer ${token}`)
    },
    afterUpload(args) {
      console.log(args)
      if (args.name === 'success') {
        console.log('tutto a posto')
        // TODO: Inserire notifica successo
      }
    },

  },
  computed: {
    hasChanged() {
      // console.log(this.regContabiliActiveData)
      // console.log(this.regContabiliSavedData)
      return Object.keys(this.regContabiliActiveData).some(field => this.regContabiliActiveData[field] !== this.regContabiliSavedData[field])
    },
  },
})

/* eslint-disable global-require */
</script>

<style lang="scss" >
@import "~@syncfusion/ej2-base/styles/material.css";
@import "~@syncfusion/ej2-buttons/styles/material.css";
@import "~@syncfusion/ej2-vue-buttons/styles/material.css";
@import '~@syncfusion/ej2-calendars/styles/material.css';
@import '~@syncfusion/ej2-calendars/styles/datepicker/material.css';
@import '~@syncfusion/ej2-dropdowns/styles/material.css';
@import "~@syncfusion/ej2-vue-popups/styles/material.css";
@import "~@syncfusion/ej2-vue-navigations/styles/material.css";
@import '~@syncfusion/ej2-inputs/styles/material.css';
@import '~@syncfusion/ej2-vue-layouts/styles/material.css';
@import '~@syncfusion/ej2-vue-richtexteditor/styles/material.css';
@import '~@syncfusion/ej2-splitbuttons/styles/material.css';
@import '~@syncfusion/ej2-grids/styles/material.css';
@import "~@syncfusion/ej2-vue-spreadsheet/styles/material.css";
@import '~@syncfusion/ej2-schedule/styles/material.css';
@import "~@syncfusion/ej2-vue-documenteditor/styles/material.css";
@import "~@syncfusion/ej2-treegrid/styles/material.css";
@import "~@syncfusion/ej2-vue-gantt/styles/material.css";
@import "~@syncfusion/ej2-vue-diagrams/styles/material.css";
@import "~@syncfusion/ej2-vue-kanban/styles/bootstrap.css";

.e-btn-icon.e-open-icon {
  background: url('~@/assets/images/svg/open2-svgrepo-com.svg');
  height: 18px;
  width: 18px;
}

.e-btn-icon.e-delete-icon {
  background: url('~@/assets/images/svg/garbage-svgrepo-com.svg');
  height: 18px;
  width: 18px;
}

.e-btn-icon.e-download-icon {
  background: url('~@/assets/images/svg/download2-svgrepo-com.svg');
  height: 18px;
  width: 18px;
}

.e-btn-icon.e-search-icon {
  background: url('~@/assets/images/svg/search-svgrepo-com.svg');
  height: 18px;
  width: 18px;
}

.e-btn-icon.e-upload-icon {
  background: url('~@/assets/images/svg/upload-svgrepo-com.svg');
  height: 18px;
  width: 18px;
}

.e-btn-icon.e-add-icon {
  background: url('~@/assets/images/svg/add2-svgrepo-com.svg');
  height: 18px;
  width: 18px;
}
</style>
